<template>
  <div class="online_main_container">
    <OnlineIcon />
    <div class="online_container gap-0">
      <h4 class="t-white f-w-700 bold-s font-family-2">
        {{ boosters_online }}
      </h4>
      <h4
        class="t-white f-w-700 bold-xs font-family-2 caps"
        style="opacity: 0.39"
      >
        {{ $t("missed.players_online") }}
      </h4>
    </div>
  </div>
</template>

<script setup>
import Cookies from "js-cookie";
import OnlineIcon from "../icons/OnlineIcon.vue";

const boosters_online = ref(0);

const fetchData = async () => {
  try {
    const minValue = 350;
    const maxValue = 450;
    
    const maxDifference = 20;
    let previousValue = Cookies.get("bm_set_r") || null;
    let randomValue = previousValue;

    if (!previousValue) {
      randomValue =
        Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue;
    }

    const in1Hour = 1 / 24;
    Cookies.set("bm_set_r", randomValue, { expires: in1Hour });
    boosters_online.value = randomValue;
  } catch (error) {
    console.log(error);
  }
};

onBeforeMount(() => {
  fetchData();
});
</script>
